import { ChangeEvent, DynamicContentType } from '@bm-js/atlascloud-shared'
import Select from './Select'
import { maxWidthOptions } from '@bm-js/atlascloud-ui'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<{ maxWidth?: string }>
  setData: (e: ChangeEvent) => void
}

const MaxWidthOptions = ({ content, setData }: Props) => {
  const { tr } = useTr()
  return (
    <Select
      light
      label={tr(TrKey.textMaxWidthLabel)}
      desc={tr(TrKey.textMaxWidthDescription)}
      id='maxWidth'
      name='maxWidth'
      value={content.data.maxWidth}
      onChange={setData}
    >
      {maxWidthOptions.map((opt) => (
        <option key={`font_maxWidth_option_${opt.value}`} value={opt.value}>
          {opt.label === 'Ingen' ? tr(TrKey.textMaxWidthOptionNone) : opt.label}
        </option>
      ))}
    </Select>
  )
}

export default MaxWidthOptions
